import React, {Component} from 'react';
import {Table} from 'antd';
import moment from 'moment';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {queryPayableAbnormal} from '@api/incubator/payable';
import {setWbTabCurrent} from '@store/modules/incubator/wb_tab_current';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      statistics: 0,
    };
  }

  componentDidMount() {
    const { currentShow } = this.props;
    this.incuUuid = this.props.incuUuid;
    this.current = currentShow.billAbormalPage || 1;
    this.getPayableAbnormal();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incuUuid !== this.props.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.props.incuUuid && (this.current = 1);
      this.getPayableAbnormal();
    }
  }

  getPayableAbnormal = () => {
    if (!this.incuUuid) {
      return;
    }
    const { pageSize } = this.props;
    queryPayableAbnormal({
      incubatorUuid: this.incuUuid || '',
      start: this.current,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data.list,
            pagination: {
              total: res.totalSize,
              pageSize: pageSize || 15,
              current: this.current,
            },
          },
          statistics: res.data.statistics,
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.getPayableAbnormal();
    const { currentShow } = this.props;
    currentShow.billAbormalPage = pagination.current;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  columns = () => {
    const { type } = this.props;
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '孵化器',
        dataIndex: 'incubator',
      },
      {
        title: '公司名称',
        dataIndex: 'custom',
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        render: (text, record) => <span>{type[text]}</span>,
      },
      {
        title: '付款时间',
        dataIndex: 'date',
        render: (text, record) =>
          text ? (
            <span>
              {moment.unix(record.date / 1000).format('YYYY-MM-DD')}(
              {record.interval > 0 ? '剩余' : '逾期'}
              {Math.ceil(Math.abs(record.interval) / 1440)}
              天)
            </span>
          ) : null,
      },
      {
        title: '待收款',
        dataIndex: 'price',
        render: (text, record) => <span>{text}</span>,
      },
      // {
      //   title: "操作",
      //   dataIndex: "termStatus", //0审核中；1已完成
      //   width: 160,
      //   render: (text, record) => {
      //     return !(text > 0 || text === 0) ? (
      //       <Link
      //         to={`/incubator/contract/${
      //           record.businessUuid
      //         }/termination`}
      //         style={{ color: "red" }}
      //       >
      //         终止合同
      //       </Link>
      //     ) : (
      //       <span>终止合同({text === 0 ? "审核中" : "已完成"})</span>
      //     );
      //   }
      // }
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      statistics,
    } = this.state;
    const { total } = pagination;
    return (
      <div>
        <div className="tips">
          异常款：逾期10-90天内账单(
          <span className="content">
            {total}笔 / {statistics}元
          </span>
          )
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
          rowKey="uuid"
        />
      </div>
    );
  }
}

export default connect(state => ({ currentShow: state.wb_tab_current }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/payables/TableAbnormal.js